import type { ProductConfig } from '#types/config/components/product'

export default {
  brandClasses: {
    badge: 'items-center gap-1 rounded px-2 py-1 text-xs c-black fw-medium i-flex'
  },
  iconSize: 'sm'
} satisfies ProductConfig['badge']
